/* Dialograhmen im Valve-Look (Titelleiste, Schließen-Knopf) und seine Bausteine. */
import type { ReactNode } from 'react';
import { useT } from './hooks.ts';

export function Dialog(props: { title: string; onClose: () => void; children: ReactNode }) {
  const t = useT();
  return (
    <div className="vlv" aria-label={props.title}>
      <div className="vlv-title">
        <span className="vlv-name">{props.title}</span>
        <button className="vlv-x" title={t('ui.close_esc')} aria-label={t('ui.close')} onClick={props.onClose}>×</button>
      </div>
      {props.children}
    </div>
  );
}

export const DialogBody = (props: { children: ReactNode }) => <div className="vlv-body">{props.children}</div>;
export const DialogFoot = (props: { children: ReactNode }) => <div className="vlv-foot">{props.children}</div>;
